/**
 * IM头部
 * author: jiaheming
 * date: 2019/06/12
 */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import actions from '../../actions';
import back from '../../static/images/mobile/back.png';

const HeaderStyle = styled.div`
    flex: 0 0 auto;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 44px;
    background: rgba(248, 248, 248, 0.82);
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.25);
    font-size: 15px;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    line-height: 17px;
`;
const BackArrow = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    background: transparent url(${back}) no-repeat center;
    background-size: 9px 17px;
    cursor: pointer;
`;
const Title = styled.div`
    max-width: 75%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

function MainHeader(props) {
    return (
        <HeaderStyle>
            <BackArrow
                onClick={() => {
                    props.closeCallback();
                }}
            />
            <Title>无讼 · 天工</Title>
        </HeaderStyle>
    );
}

MainHeader.propTypes = {
    closeCallback: PropTypes.func,
};

function ChatHeader(props) {
    const { title, closeChat, resetSession } = props;
    return (
        <HeaderStyle>
            <BackArrow
                onClick={() => {
                    resetSession();
                    closeChat();
                }}
            />
            <Title>{title}</Title>
        </HeaderStyle>
    );
}

ChatHeader.propTypes = {
    title: PropTypes.string.isRequired,
    closeChat: PropTypes.func.isRequired,
    resetSession: PropTypes.func.isRequired,
};
const ConnectedChatHeader = connect(null, {
    closeChat: actions.closeChat,
    resetSession: actions.resetCurrSession,
})(ChatHeader);

export { MainHeader, ConnectedChatHeader as ChatHeader };
